import { useQuery } from '@tanstack/react-query';
import { CommonKey } from '../../types/api';
import * as fns from 'date-fns';
import sportsApi from '../../utils/sportsApi';
import * as R from 'ramda';

const getReport = async query => {
    if (!query) return;

    // Startdate is required. Set to EPOCH if not set.
    const fullQuery = R.mergeLeft(query, {
        startDate: fns.format(new Date(0), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
    });

    const endpoint = `/media-value-reports`;

    return await sportsApi.url(endpoint).json(fullQuery).post().json();
};

type UseMediaValueReportOptions = {
    enabled?: boolean;
};

export const useMediaValueReport = (
    query,
    { enabled = true }: UseMediaValueReportOptions = {},
) =>
    useQuery({
        queryKey: [CommonKey.MediaValueReport, query],
        queryFn: () => getReport(query),
        staleTime: 240000,
        enabled: enabled && !!query,
    });
